export default {
    ca: {
        heading: {
            title: 'Carregant',
            message: 'Recuperant informació del servidor, no trigarà gaire',
        },
    },
    es: {
        heading: {
            title: 'Cargando',
            message: 'Recuperando información del servidor, no tardará mucho',
        },
    },
    en: {
        heading: {
            title: 'Loading',
            message: 'Gathering data from server, it won\'t take long',
        },
    },
};



// WEBPACK FOOTER //
// ./src/shared/components/loader/loader-translations.js